export class PoleColor {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const PoleColorsChoices = {
  WHITE: new PoleColor('Wit', 0),
  BLACK: new PoleColor('Zwart', 1),
  GREY: new PoleColor('Grijs', 2)
};

export const PoleColorsChoiceArray = Object.values(PoleColorsChoices);
